import FeaturesOverview from "@/components/FeaturesOverview";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { FC } from "react";

type FeaturesOverviewBlockProps = {
  theme?: "black" | "gray" | "white";
  children?: React.ReactNode;
} & BuilderProps;

export const FeaturesOverviewBlock: FC<FeaturesOverviewBlockProps> = ({
  theme,
  children,
}) => {
  return <FeaturesOverview theme={theme}>{children}</FeaturesOverview>;
};
